<template>
  <div class="menu">
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          :default-active="menuIndex"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#4A4E51"
          text-color="#fff"
          active-text-color="#ffd04b"
          :unique-opened="true"
          :default-openeds="openedMenu"
        >
          <!-- <el-menu-item index="1" @click="goPage('/', '1')">
						<i class="el-icon-house"></i>
						<span slot="title">首页</span>
					</el-menu-item> -->
          <!-- <el-submenu index="2">
						<template slot="title">
							<i class="el-icon-menu"></i>
							<span @click="goPage('/')">版块列表</span>
						</template>
						<el-menu-item-group>
							<el-menu-item
								:index="items.name"
								v-for="items in menu"
								:key="items.name"
								@click="go(items,items.name,items)"
							>{{replace(items.name)}}</el-menu-item>
						</el-menu-item-group>
					</el-submenu> -->
          <!-- <el-menu-item index="6" @click="goPage('/manageComparison', '6')">
						<i class="el-icon-document-copy"></i>
						<span slot="title">车型对比</span>
					</el-menu-item> -->
          <el-submenu
            index="5"
            v-if="computedPermission(['管理员', '任务导师', '问卷导师', ''])"
          >
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>我的任务</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="qwrwcx"
                @click="goPage('/manage/allQuery', 'qwrwcx')"
                >全网任务查询</el-menu-item
              >
              <!-- <el-menu-item
                index="wdrw"
                @click="goPage('/manage/myPoints', 'wdjf')"
                >我的积分</el-menu-item
              > -->
              <el-menu-item
                index="wdrw"
                @click="goPage('/manage/myTask', 'wdrw')"
                >我的任务</el-menu-item
              >
              <el-menu-item
                index="wdxx"
                @click="goPage('/manage/myMessage', 'wdxx')"
                >我的消息</el-menu-item
              >
              <el-menu-item
                index="wdpf"
                @click="goPage('/manage/mySend', 'wdpf')"
                v-if="computedPermission(['任务导师'])"
                >我的派发</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4" v-if="computedPermission(['问卷导师'])">
            <template slot="title">
              <i class="el-icon-house"></i>
              <span>问卷调查</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="wdwj"
                @click="goPage('/manage/myQuestion', 'wdwj')"
                >我的问卷</el-menu-item
              >
              <el-menu-item
                index="cjwj"
                @click="goPage('/manage/createQuestion', 'cjwj')"
                >创建问卷</el-menu-item
              >
              <!-- <el-menu-item
								index="fxxz"
								@click="goPage('/manage/analysis', 'fxxz')"
								v-if="$h5Power == 'admin'"
								>分析下载</el-menu-item
							> -->
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3" v-if="computedPermission(['管理员'])">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>后台管理</span>
            </template>
            <el-menu-item-group>
              <!-- <el-menu-item index="rgsh" @click="goPage('/admin?type=' + 1,'rgsh')" v-if="$h5Power=='teacher' || $h5Power=='admin'">人工审核</el-menu-item>
							<el-menu-item index="hdgl" @click="goPage('/admin?type=' + 2,'hdgl')" v-if="$h5Power=='teacher' || $h5Power=='admin'">回答管理</el-menu-item>
							<el-menu-item index="gdgl" @click="goPage('/admin?type=' + 3,'gdgl')" v-if="$h5Power=='teacher' || $h5Power=='admin'">归档管理</el-menu-item>
							<el-menu-item index="wtgl" @click="goPage('/manage/question?type=' + 8,'wtgl')" v-if="$h5Power=='admin'">问题管理</el-menu-item> -->

              <el-menu-item
                index="yhgl"
                @click="goPage('/manage/user?type=' + 7, 'yhgl')"
                >用户列表</el-menu-item
              >
              <el-menu-item
                index="glz"
                @click="goPage('/manage/manageGroup', 'glz')"
                >管理组</el-menu-item
              >
              <el-menu-item
                index="gggl"
                @click="goPage('/manage/announcement?type=' + 5, 'gggl')"
                >导师任务管理</el-menu-item
              >
              <el-menu-item
                index="wjgl"
                @click="goPage('/manage/questionManage?type=' + 11, 'wjgl')"
                >问卷管理</el-menu-item
              >

              <!-- <el-menu-item index="mgcgl" @click="goPage('/manage/sensitive?type=' + 4,'mgcgl')" v-if="$h5Power=='admin'">敏感词管理</el-menu-item>
							<el-menu-item index="gggl" @click="goPage('/manage/announcement?type=' + 5,'gggl')" v-if="$h5Power=='admin'">公告管理</el-menu-item>
							<el-menu-item index="zzmys" @click="goPage('/manage/organisation?type=' + 6,'zzmys')" v-if="$h5Power=='admin'">组织名映射</el-menu-item>
							<el-menu-item index="htwh" @click="goPage('/manage/backStage?type=' + 9,'htwh')" v-if="$h5Power=='admin'">版块维护</el-menu-item>
							<el-menu-item index="cxxx" @click="goPage('/manage/modelInformation?type=' + 10,'cxxx')" v-if="$h5Power=='admin'">车型信息管理</el-menu-item>  -->
            </el-menu-item-group>
          </el-submenu>

          <!-- <el-menu-item index="4" @click="goPage('/message', '4')" style="position:relative">
						<i class="el-icon-bell"></i>
						<span slot="title">提醒</span>
					</el-menu-item>
					<el-menu-item index="5" @click="goPage('/me', '5')">
						<i class="el-icon-user"></i>
						<span slot="title">个人中心</span>
					</el-menu-item> -->
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { hasEqualValue } from "@/common/utils.js";
export default {
  data() {
    return {
      menu: [],
      red: [],
      menuIndex: "1",
      openedMenu: ["3"],
    };
  },
  components: {},
  computed: {
    computedPermission() {
      return function (array) {
        let roleName = this.$h5RoleName ? this.$h5RoleName.split("|") : [""];
        return hasEqualValue(roleName, array);
      };
    },
  },
  mounted() {
    thisPC.$on("abcde", (data) => {
      this.red = data.red;
    });

    this.h5Ajax("get", "$/events/userCount", {}, true)
      .then((res) => {
        this.red = res;
      })
      .catch((err) => {
        // console.error("err:" + err);
      });

    // 板块分类
    // this.h5Ajax("get", "$/category/listByPid", {
    // 		pid:1
    // }, true)
    // 	.then(res => {
    // 		console.log(res, "获取某个PID下的分类数据");
    // 		// this.menu = res
    // 	})
    // 	.catch(err => {
    // 		console.error("err:" + err);
    // });
    setTimeout(() => {}, 100);
    /* thisPC.$on('menu', data => {
			console.log(data)
			this.menuIndex = data.x;
		}) */
    this.menuIndex = localStorage.getItem("menuIndex") || "1";
    console.log(this.menuIndex, "menuIndex");
    /* if (
			window.location &&
			window.location.hash &&
			window.location.hash === "#/me"
		) {
			this.menuIndex, "5";
		} */
  },
  methods: {
    replace(text) {
      var reg = new RegExp("<br/>", "g");
      var x = text.replace(reg, "");
      return x;
    },
    go(items, data, item) {
      if (data == "积分榜") {
        this.$router.push({ path: "/manage/leagueTable" });
        window.localStorage.setItem("menuIndex", data);
      } else {
        this.$router.push({
          path: "/model/list",
          query: { type: items.name, id: items.id },
        });
        window.localStorage.setItem("menuIndex", data);
      }
    },
    goPage(url, data) {
      this.$router.push({ path: url });
      window.localStorage.setItem("menuIndex", data);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  width: 100%;
  /deep/ .el-submenu__icon-arrow {
    color: #fff;
  }
  /deep/ .is-active {
    color: #fff !important;
    background-color: #d5001c !important;
  }
  /deep/ .el-submenu {
    .el-menu-item {
      width: 260px;
      height: 30px;
      line-height: 30px;
      padding-left: 51px !important;
      font-weight: 100;
      background-color: rgb(127, 127, 127) !important;
    }
    .is-active {
      background-color: #d5001c !important;
    }
    .el-menu-item:hover {
      background-color: rgb(59, 62, 65) !important;
    }
  }
  /deep/ .el-menu-item-group__title {
    padding: 0;
  }
  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    width: 260px;
    height: 36px;
    line-height: 36px;
    font-weight: 800;
  }

  .div {
    position: absolute;
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background: red;
    top: 10px;
    left: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pc/components/menu.vue